import { render } from "./TaxeFonciereList.vue?vue&type=template&id=8f8620b4"
import script from "./TaxeFonciereList.vue?vue&type=script&lang=js"
export * from "./TaxeFonciereList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__